// removed by extract-text-webpack-plugin
module.exports = {"content":"AdminDashboard__content__2U5xS","parentContainer":"AdminDashboard__parentContainer__2vSpM","wrapper":"AdminDashboard__wrapper__1q4Gz","viewIcon":"AdminDashboard__viewIcon__2lN_N","selectClear":"AdminDashboard__selectClear__2qmUN"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/AdminDashboard/AdminDashboard.css
// module id = 1142
// module chunks = 0